'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { dc, uc, pc, mc, hc, _c, gc } from './collection-direction';
import { V, Ts } from './collection-artifact-primitives';
import { BlurSwap } from './playback-controls';
export function vc(e) {
  if (e < 500) return null;
  if (e >= dc)
    return {
      row: V.length + 1,
      col: 4,
    };
  if (e >= uc)
    return {
      row: V.length + 1,
      col: 3,
    };
  for (let t = V.length - 1; t >= 0; --t)
    for (let n = pc.length - 1; n >= 0; --n)
      if (e >= mc(t, n))
        return {
          row: t + 1,
          col: n,
        };
  return {
    row: 1,
    col: 0,
  };
}
export function yc(e) {
  let t = vc(e);
  if (!t)
    return {
      ref: 'A2',
      text: '',
    };
  let n = pc[t.col],
    r = `${n?.letter ?? 'A'}${t.row + 1}`;
  return t.row === V.length + 1
    ? {
        ref: r,
        text: t.col === 3 ? '=AVERAGE(D2:D7)' : '=SUM(E2:E7)',
      }
    : {
        ref: r,
        text: n ? hc(t.row - 1, n.key) : '',
      };
}
export const bc =
  'flex h-[30px] min-w-0 items-center border-r border-b border-[var(--cf-grid)] px-1.5 text-[12px] leading-4 sm:px-2 sm:text-[12.5px]';
export const xc = (e) => (e.wide ? 'max-sm:hidden' : '');
export const Sc = (e) => (e.numeric ? 'justify-end num' : '');
export function LinePlanGrid({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = vc(e),
    n = _c(e),
    r = gc(e),
    i = V.length + 1,
    a = (e, n) => (t && t.row === e && t.col === n ? 'cf-cell-active' : ''),
    o = (e) =>
      `flex h-6 items-center justify-center border-r border-b border-[var(--cf-grid)] text-[11px] font-medium transition-colors duration-150 ${e ? 'text-ink bg-[var(--cf-head-on)]' : 'text-ink-3 bg-[var(--cf-head)]'}`;
  return (
    <div
      role={'table'}
      aria-label={translateShowcaseNode(
        showcaseCopy,
        'LISI\xC8RE FW27 line plan (illustrative)'
      )}
      className={
        'cf-sheet grid min-w-0 border-t border-l border-[var(--cf-grid)]'
      }
    >
      <span aria-hidden={!0} className={o(!1)} />
      {translateShowcaseNode(
        showcaseCopy,
        pc.map((e, n) => (
          <span
            key={e.letter}
            aria-hidden={!0}
            className={`${o(t?.col === n)} ${xc(e)}`}
          >
            {translateShowcaseNode(showcaseCopy, e.letter)}
          </span>
        ))
      )}
      <span
        aria-hidden={!0}
        className={`${bc} text-ink-3 justify-end bg-[var(--cf-head)] px-1.5 text-[11px]`}
      >
        {translateShowcaseNode(showcaseCopy, '1')}
      </span>
      {translateShowcaseNode(
        showcaseCopy,
        pc.map((e) => (
          <span
            key={e.key}
            role={'columnheader'}
            className={`${bc} text-ink font-semibold ${xc(e)} ${Sc(e)}`}
          >
            {translateShowcaseNode(
              showcaseCopy,
              e.short ? (
                <React.Fragment>
                  <span className={'sm:hidden'}>
                    {translateShowcaseNode(showcaseCopy, e.short)}
                  </span>
                  <span className={'max-sm:hidden'}>
                    {translateShowcaseNode(showcaseCopy, e.head)}
                  </span>
                </React.Fragment>
              ) : (
                e.head
              )
            )}
          </span>
        ))
      )}
      {translateShowcaseNode(
        showcaseCopy,
        V.map((n, r) => {
          let i = r + 1;
          return (
            <React.Fragment key={n.style}>
              <span
                aria-hidden={!0}
                className={`${bc} justify-end px-1.5 text-[11px] transition-colors duration-150 ${t?.row === i ? 'text-ink bg-[var(--cf-head-on)]' : 'text-ink-3 bg-[var(--cf-head)]'}`}
              >
                {translateShowcaseNode(showcaseCopy, i + 1)}
              </span>
              {translateShowcaseNode(
                showcaseCopy,
                pc.map((t, o) => {
                  let s = e >= mc(r, o),
                    c =
                      t.key === 'price'
                        ? Ts(n.price)
                        : t.key === 'options'
                          ? String(n.options)
                          : n[t.key];
                  return (
                    <span
                      key={t.key}
                      role={'cell'}
                      className={`${bc} relative ${xc(t)} ${Sc(t)} ${a(i, o)} ${t.key === 'style' ? 'text-ink' : 'text-ink-2'}`}
                    >
                      <span
                        className={'truncate transition-opacity duration-150'}
                        style={{
                          opacity: +!!s,
                        }}
                      >
                        {translateShowcaseNode(showcaseCopy, c)}
                      </span>
                    </span>
                  );
                })
              )}
            </React.Fragment>
          );
        })
      )}
      <span
        aria-hidden={!0}
        className={`${bc} justify-end px-1.5 text-[11px] ${t?.row === i ? 'text-ink bg-[var(--cf-head-on)]' : 'text-ink-3 bg-[var(--cf-head)]'}`}
      >
        {translateShowcaseNode(showcaseCopy, i + 1)}
      </span>
      {translateShowcaseNode(
        showcaseCopy,
        pc.map((e, t) => {
          let o =
              e.key === 'style'
                ? 'Total'
                : e.key === 'role'
                  ? `${n.styles} styles`
                  : e.key === 'price'
                    ? n.avg
                      ? `avg ${Ts(n.avg)}`
                      : '\u2013'
                    : e.key === 'options'
                      ? String(n.options)
                      : '',
            s = e.key === 'price' || e.key === 'options' || e.key === 'role';
          return (
            <span
              key={e.key}
              role={'cell'}
              className={`${bc} relative bg-[var(--cf-total)] font-medium ${xc(e)} ${Sc(e)} ${a(i, t)} ${e.key === 'style' ? 'text-ink' : 'text-ink-2'}`}
            >
              {translateShowcaseNode(
                showcaseCopy,
                s ? <span key={r} className={r > 0 ? 'cf-recalc' : ''} /> : null
              )}
              <span className={'relative truncate'}>
                {translateShowcaseNode(
                  showcaseCopy,
                  s ? <BlurSwap value={o} /> : o
                )}
              </span>
            </span>
          );
        })
      )}
    </div>
  );
}
export const wc = 300;
export const Tc = (e) => ((e - wc) / 1500) * 100;
export const Ec = {
  Hero: 'bg-[var(--foreground)] shadow-[0_0_0_1.5px_var(--foreground)]',
  Core: 'bg-[var(--muted-foreground)] shadow-[0_0_0_1.5px_var(--muted-foreground)]',
  Entry: 'bg-[var(--panel)] shadow-[inset_0_0_0_1.5px_var(--muted-foreground)]',
};
export const Dc = ['Entry', 'Core', 'Hero'];
export const Oc = (e) => mc(e, pc.length - 1);
export const kc = Dc.map((e) => {
  let t = V.map((e, t) => ({
      piece: e,
      row: t,
    })).filter((t) => t.piece.role === e),
    n = t.map((e) => e.piece.price),
    r = Math.min(...n),
    i = Math.max(...n);
  return {
    role: e,
    low: r,
    high: i,
    at: Math.max(...t.map((e) => Oc(e.row))),
    text: r === i ? Ts(r) : `${Ts(r)}–${Ts(i).slice(1)}`,
  };
});
export function PriceLadder({ t: e, start: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let n = e >= t;
  return (
    <div aria-hidden={!0} className={'px-1'}>
      <div className={'flex items-center justify-between gap-3'}>
        <p className={'label'}>
          {translateShowcaseNode(showcaseCopy, 'Proposed price ladder')}
        </p>
        <span
          className={'text-ink-4 flex items-center gap-3 text-[11px] leading-4'}
        >
          {translateShowcaseNode(
            showcaseCopy,
            Dc.map((e) => (
              <span key={e} className={'flex items-center gap-1.5'}>
                <span className={`size-1.5 rounded-full ${Ec[e]}`} />
                {translateShowcaseNode(showcaseCopy, e)}
              </span>
            ))
          )}
        </span>
      </div>
      <div className={'relative mt-2 h-[52px]'}>
        {translateShowcaseNode(
          showcaseCopy,
          kc.map((t) => {
            let n = e >= t.at,
              r = t.role === 'Core',
              i =
                t.role === 'Entry'
                  ? {
                      left: `${Tc(t.low)}%`,
                      transform: 'translateX(-6px)',
                    }
                  : t.role === 'Hero'
                    ? {
                        right: `${100 - Tc(t.high)}%`,
                        transform: 'translateX(6px)',
                      }
                    : {
                        left: `${(Tc(t.low) + Tc(t.high)) / 2}%`,
                        transform: 'translateX(-50%)',
                      };
            return (
              <span
                key={t.role}
                className={`num text-ink-3 absolute text-[11px] leading-4 whitespace-nowrap transition-opacity duration-300 ${r ? 'bottom-0' : 'top-0'}`}
                style={{
                  ...i,
                  opacity: +!!n,
                }}
              >
                <span className={'text-ink-2'}>
                  {translateShowcaseNode(showcaseCopy, t.role)}
                </span>
                {translateShowcaseNode(showcaseCopy, ' ')}
                {translateShowcaseNode(showcaseCopy, t.text)}
              </span>
            );
          })
        )}
        {translateShowcaseNode(
          showcaseCopy,
          kc
            .filter((e) => e.low !== e.high)
            .map((t) => (
              <span
                key={t.role}
                className={
                  'absolute top-[calc(50%-5px)] h-2.5 rounded-full bg-[var(--state-wash)] transition-opacity duration-300'
                }
                style={{
                  left: `calc(${Tc(t.low)}% - 5px)`,
                  width: `calc(${Tc(t.high) - Tc(t.low)}% + 10px)`,
                  opacity: +(e >= t.at),
                }}
              />
            ))
        )}
        <span
          className={
            'absolute inset-x-0 top-1/2 h-px origin-left bg-[var(--line-strong)] transition-transform duration-[700ms] ease-[var(--ease)]'
          }
          style={{
            transform: n ? 'none' : 'scaleX(0)',
          }}
        />
        {translateShowcaseNode(
          showcaseCopy,
          V.map((t, n) => {
            let r = e >= Oc(n);
            return (
              <span
                key={t.name}
                className={`absolute top-1/2 size-2 rounded-full transition-[transform,opacity] duration-[420ms] ease-[var(--ease)] ${Ec[t.role]}`}
                style={{
                  left: `${Tc(t.price)}%`,
                  opacity: +!!r,
                  transform: `translate(-50%, ${r ? '-50%' : '-260%'}) scale(${r ? 1 : 0.6})`,
                }}
              />
            );
          })
        )}
      </div>
    </div>
  );
}
